import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  paper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.up('mobile')]: {
      display: 'unset',
    },
  },
  item: {
    marginBottom: theme.spacing(3),
  },
  itemLabel: {
    marginBottom: 4,
  },
  value: {
    fontSize: 20,
    [theme.breakpoints.up('mobile')]: {
      fontSize: 24,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/IntermediateResults/useStyles.js